// extracted by mini-css-extract-plugin
export default {"extraMargin":"TabsWrapper_extraMargin__7wh2O","tabs":"TabsWrapper_tabs__FvbaX"};